var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('h2',[_vm._v("Search and add a pin")]),_c('label',[_c('gmap-autocomplete',{on:{"place_changed":_vm.setPlace}}),_c('button',{on:{"click":_vm.addMarker}},[_vm._v("Add")])],1),_c('br')]),_c('br'),_c('gmap-map',{staticStyle:{"width":"100%","height":"400px"},attrs:{"options":{
      zoomControl: true,
      mapTypeControl: true,
      scaleControl: false,
      streetViewControl: false,
      rotateControl: false,
      fullscreenControl: true,
      disableDefaultUi: false
    },"center":_vm.center,"zoom":12}},_vm._l((_vm.markers),function(m,index){return _c('gmap-marker',{key:index,attrs:{"position":m.position},on:{"click":function($event){_vm.center=m.position}}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }